import * as React from "react";
import { OpeningsSpecialDates, OpeningsTexts, OpeningsWeek } from ".";
import { CustomerOpenings } from "@TmpApp/types";

export type OpeningsProps = { texts?: OpeningsTexts } & (
    | {
          openings: CustomerOpenings;
          loading?: false;
      }
    | {
          openings?: CustomerOpenings;
          loading: true;
      }
);

const Openings: React.FC<OpeningsProps> = ({ openings, loading = false, texts, ...props }) => {
    return (
        <>
            <OpeningsWeek week={openings?.week} loading={loading} texts={texts} />
            {!loading && <OpeningsSpecialDates dates={openings.special} texts={texts} />}
        </>
    );
};

export default Openings;
